export default {
      id: "funnel-20-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#funnel-20-usage",
      toString: function () {
        return this.url;
      }
    }